import { accessibleOnClick } from '@package/helpers/accessibleOnClick';
import PropTypes from 'prop-types';

const EventModal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div className="event-modal-overlay" {...accessibleOnClick(onClose)}>
      <div
        className="event-modal"
        {...accessibleOnClick((e) => e.stopPropagation())}
      >
        <button
          className="event-modal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>
        <div className="event-modal-content">{children}</div>
      </div>
    </div>
  );
};

EventModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default EventModal;
